// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3KZCa","addWidgetButton":"Header_addWidgetButton__1AuT6","dashboardTabs":"Header_dashboardTabs__uldJE","active":"Header_active__1Otyd"};